import { variables } from '@indriver/yrel';

var preset = {
  fontFamily: variables['font-family-noto'],
  fontSize: {
    xxs: variables['font-size-xxs'],
    xs: variables['font-size-xs'],
    s: variables['font-size-s'],
    m: variables['font-size-m'],
    ml: variables['font-size-ml'],
    l: variables['font-size-l'],
    xl: variables['font-size-xl'],
    xxl: variables['font-size-xxl'],
    xxxl: variables['font-size-xxxl']
  },
  lineHeight: {
    xxs: variables['line-height-xxs'],
    xs: variables['line-height-xs'],
    s: variables['line-height-s'],
    m: variables['line-height-m'],
    ml: variables['line-height-ml'],
    l: variables['line-height-l'],
    xl: variables['line-height-xl'],
    xxl: variables['line-height-xxl'],
    xxxl: variables['line-height-xxxl']
  },
  fontWeight: {
    normal: variables['font-weight-normal'],
    regular: variables['font-weight-regular'],
    medium: variables['font-weight-medium'],
    'semi-bold': variables['font-weight-semi-bold'],
    bold: variables['font-weight-bold']
  }
};

export { preset as default };
